import React, { useMemo } from "react";
import { Divider } from "@mui/material";
import RouteSelect from "../reusables/RouteSelect";

/**
 * Pure UI component for Slack Notification
 * All logic is handled by useNotificationAction hook
 */
const SlackNotificationUI = ({
  channelValue,
  handleChannelChange,
  handleRemove,
  containerClass,
  inputClass,
  headerSize,
  subtitleSize,
  useIVRStyle,
  setOpenConfigureNotificationModal,
  channels = [],
  hasValidationError = false,
  addChannelOption,
}) => {
  const filteredChannels = channels.filter((item) => item.M.type.S == "slack");
  const channelOptions = useMemo(() => {
    return filteredChannels.map((item) => {
      const label = item.M.label?.S || "";
      const displayValue = item.M.value?.S || "";
      const value = item.M.ch_id?.S ?? item.M.ch_id;
      return { value, label: label ? `${label} - ${displayValue}` : displayValue };
    });
  }, [filteredChannels]);

  return (
    <div className={`${containerClass}${hasValidationError ? " !bg-red-50/80" : ""}`}>
      {/* Header */}
      <div className={`flex flex-nowrap items-center justify-between gap-3 ${useIVRStyle ? "mb-3" : "mb-5"}`}>
        <div className="flex items-center min-w-0 flex-1">
          <img
            src="/icons/slack.png"
            className="text-[#4F46E5] mr-2 w-[25px] h-[25px] shrink-0"
            alt="Slack"
          />
          <div className="min-w-0">
            <h2 className={`${headerSize} text-gray-800`}>
              Slack Notification
            </h2>
            {!useIVRStyle && (
              <div className={subtitleSize}>Send Slack messages</div>
            )}
          </div>
        </div>
        <div className="flex shrink-0 items-center space-x-2">
          {setOpenConfigureNotificationModal && (
            <button
              className={`shrink-0 whitespace-nowrap text-sm text-blue-600 font-medium hover:underline ${useIVRStyle ? "text-[10.7px]" : "text-[13px]"}`}
              onClick={() => setOpenConfigureNotificationModal(true)}
            >
              ↻ Change
            </button>
          )}
          {handleRemove && (
            <button
              className={`text-red-600 font-medium hover:underline ${useIVRStyle ? "text-[10.7px]" : "text-[12px]"}`}
              onClick={handleRemove}
            >
              Remove
            </button>
          )}
        </div>
      </div>

      {useIVRStyle && <Divider className="border-gray-200 mb-4" />}

      {/* Channel Selection */}
      <div className={useIVRStyle ? "" : "mb-4"}>
        <div className="flex items-center gap-1 mb-1">
          <span className="text-sm font-medium text-gray-700">Channel</span>
        </div>
        <RouteSelect
          value={channelValue || ""}
          onChange={handleChannelChange}
          options={channelOptions}
          placeholder="Select a channel"
          addOption={addChannelOption}
        />
      </div>
    </div>
  );
};

export default SlackNotificationUI;
